import React from 'react';

import RadioInputWithIcon from 'components/atoms/Input/RadioInputWithIcon';
import './index.scss';

const PcHowToDo = ({ value, checked, label, subLabel, point, icon, onChange, id }) => {

  return (
    <div className="PcHowToDo">
      <span className="radioArea">
        <div className="point">{point}</div>
        <RadioInputWithIcon value={value} checked={checked} label={label} subLabel={subLabel} icon={icon} onChange={onChange} id={id} />
      </span>
    </div>
  );
};

export default PcHowToDo;